<script>
    import Fa from 'svelte-fa';
    import { faChevronRight, faChevronLeft } from '@fortawesome/pro-regular-svg-icons';

    import { onMount } from 'svelte';
    import { page } from '$app/stores';
    import { replaceState } from '$app/navigation';
    import { debounce } from '$lib/utils/functions/debounce';

    export let key;
    export let showButtons = true;

    // Scroll container lets
    let container;
    let carouselID = `carousel-${key}`;
    let scrollY;

    // scroll carousel container on btn click
    const scrollCarouselContainer = (direction) => {
        if (direction === 'right') {
            container.scrollLeft += 296.5;
        } else {
            container.scrollLeft -= 296.5;
        }
    };

    // Replace state of last known movement of carousel
    const updateState = (currentCarouselID, currentXscroll) => {
        if (currentCarouselID && currentXscroll) {
            replaceState('', {
                currentPageYScroll: scrollY,
                currentXscroll: currentXscroll,
                currentCarouselID: currentCarouselID
            });
        }
    };

    // Debounce the updateState function
    const updateStateDebounced = debounce(updateState, 100);

    // Reset carousel scroll position from $page.state
    onMount(() => {
        const resetContainer = document.getElementById($page?.state?.currentCarouselID);
        const currentXscroll = $page?.state?.currentXscroll;
        const currentPageYScroll = $page?.state?.currentPageYScroll;

        if (resetContainer && currentXscroll) {
            // reset main container
            resetContainer.scrollLeft = currentXscroll;

            // temp fix to make sure page scroll is in last known position
            setTimeout(() => {
                if (scrollY === currentPageYScroll) scrollTo(0, currentPageYScroll);
            }, 10);
        }
    });
</script>

<svelte:window bind:scrollY />

{#if showButtons}
    <div class="absolute -top-14 right-0 z-20 flex items-end gap-x-3">
        <button
            class="inline-flex rounded-lg bg-base-700 px-3 py-2 shadow-sm lg:py-2.5"
            aria-label="Scroll Left"
            on:click={() => scrollCarouselContainer('left')}
        >
            <Fa icon={faChevronLeft} class="text-color-text" />
        </button>
        <button
            class="inline-flex rounded-lg bg-base-700 px-3 py-2 shadow-sm lg:py-2.5"
            aria-label="Scroll Right"
            on:click={() => scrollCarouselContainer('right')}
        >
            <Fa icon={faChevronRight} class="text-color-text" />
        </button>
    </div>
{/if}

<div
    id={carouselID}
    class="no-scrollbar flex w-full snap-x snap-mandatory items-center gap-2 overflow-x-scroll scroll-smooth will-change-scroll"
    bind:this={container}
    on:scrollend={() => {
        updateStateDebounced(carouselID, container.scrollLeft);
    }}
>
    <slot />
</div>
